module.exports = __webpack_public_path__ + "img/office.5e6920c2.png";